const changeTheme = (newThemeName) => {

  document.getElementById('app').className = newThemeName;

}

export default changeTheme;